import React from 'react';
import PropTypes from 'prop-types';
import { getPointsAndRewardsData } from './plpTileHelpers/plpTileCommonHelpers';
import PointRewardText from './styles/PointsAndRewards.style';

const PointsAndRewards = ({ isBrierleyPromoEnabled, pointsAndRewardsText }) => {
  const { text1, text2, text3, shoudRender } = getPointsAndRewardsData({
    isBrierleyPromoEnabled,
    pointsAndRewardsText,
  });
  return shoudRender ? (
    <div className="points-and-rewards">
      <PointRewardText type="left">{text1}</PointRewardText>
      <PointRewardText type="middle">{text2}</PointRewardText>
      <PointRewardText type="right">{text3}</PointRewardText>
    </div>
  ) : null;
};
PointsAndRewards.propTypes = {
  isBrierleyPromoEnabled: PropTypes.bool,
  pointsAndRewardsText: PropTypes.string,
};
PointsAndRewards.defaultProps = {
  isBrierleyPromoEnabled: false,
  pointsAndRewardsText: '',
};
export default PointsAndRewards;
